import { render } from "./CreateInfoService.vue?vue&type=template&id=2282b02e&scoped=true"
import script from "./CreateInfoService.vue?vue&type=script&lang=js"
export * from "./CreateInfoService.vue?vue&type=script&lang=js"

import "./CreateInfoService.vue?vue&type=style&index=0&id=2282b02e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2282b02e"]])

export default __exports__